import styled from "styled-components";

export const Content = styled.div<{ wide?: boolean }>`
  max-width: ${({ wide }) => wide ? '1144px' : '918px'};
  margin: 0 auto;
`;
